module.exports = __webpack_public_path__ + "img/01.3f6a102a.jpg";